import {
  type RuleCheckResult,
  type ScreeningDocument,
} from "@/services/api/guardiansv2/types";

export function programmaticSignalFailures(screening: ScreeningDocument | null): RuleCheckResult[] {
  if (!screening) return [];
  const { checks } = screening.checks;
  return checks.filter((c) => c.kind === "signal" && c.status === "failed");
}

export function canIgnoreAlert(screening: ScreeningDocument | null): boolean {
  return programmaticSignalFailures(screening).length > 0;
}

export function signalTypeFromCheck(check: RuleCheckResult): string | null {
  const fromObserved = check.observed?.signal_type;
  if (typeof fromObserved === "string" && fromObserved.trim()) {
    return fromObserved;
  }
  if (check.signal_type?.trim()) {
    return check.signal_type;
  }
  return check.rule_id ?? null;
}
